export default "__VITE_ASSET__48653990__"